import Swiper, { Navigation, Pagination, Lazy, Thumbs } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Lazy,
        Thumbs
    ]);
    new Swiper('.js-about-carousel', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 12,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 28
            }
        }
    });
    const thumbs = new Swiper('.js-about-thumbs', {
        spaceBetween: 30,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 70
            }
        }
    });
    const logos = new Swiper('.js-about-logos', {
        spaceBetween: 10,
        slidesPerView: 1,
        thumbs: {
            swiper: thumbs
        }
    });
    thumbs.init();
    logos.init();
};
